import { render, staticRenderFns } from "./request-friend.vue?vue&type=template&id=22ce1150&"
import script from "./request-friend.js?vue&type=script&lang=js&"
export * from "./request-friend.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports